import SessionActions from '@modules/session-sdo';
import {SimpleModal} from '@modules/simple-modal';
import {
  localStorageKeys,
  modals,
  pages,
  landingPageProducts,
  sdoNs,
  userTypes,
  products
} from '@modules/constants-enumerate';
import {storeInstance} from '@aofl/store/dist/legacy';
import {routerInstance} from '@aofl/router';
import {Toast} from '@modules/toast';
import {I18n} from '@aofl/i18n';
import translations from '@modules/i18n';
import {toastStatus} from '@modules/i18n-labels';

class LoginActions {
  i18n = {};

  constructor() {
    this.i18n = new I18n(translations);
    this.i18n.lang = localStorage.getItem(localStorageKeys.LANG);
    storeInstance.subscribe(() => {
      const state = storeInstance.getState();
      this.i18n.lang = state[sdoNs.SESSION].locale;
    });
  }

  static isCurrentMasteryProduct(aoflProducts) {
    return aoflProducts[products.MY_MATH_ACADEMY]
      || aoflProducts[products.MY_READING_ACADEMY]
      || aoflProducts[products.MY_READING_ACADEMY_ES];
  }

  static async login(username, password, url = '', mfaRemember = false, mfaMethod = '', mfaToken = '') {
    const data = await SessionActions.login(username, password, mfaRemember, mfaMethod, mfaToken);
    data.username = username;
    data.password = password;
    await this.handleLogin(data, url);
  }

  static async handleLogin(data, url) {
    if (url === '' || url === pages.DASHBOARD || url === pages.LANDING) {
      // route to landing or dashboard here
      let showLanding = false;
      let routeToLanding = false;
      for (const product of landingPageProducts) {
        const hasProduct = data.session.settings.aofl_products[product] !== undefined
          ? data.session.settings.aofl_products[product]
          : false;
        if (hasProduct) {
          showLanding = true;
          routeToLanding = true;
        }
      }

      if (data.session.settings.aofl_products[products.MATH_ACADEMY]) {
        routeToLanding = false;
      }

      url = (showLanding && routeToLanding) ? pages.LANDING : pages.DASHBOARD;
      // go to the new getting started page if you are part of the current mastery product and has no roster data
      if (
        data.session.settings.has_roster_data === false
        && this.isCurrentMasteryProduct(data.session.settings.aofl_products)
      ) {
        url = pages.GETTING_STARTED;
      }
    }

    // multi-factor auth
    if (data.session === null || data.mfa_status === 'required-not-configured') {
      if (data.mfa_status === 'active' || data.mfa_status === 'required') {
        SimpleModal.show(modals.MFA_ENTER, {'username': data.username, 'password': data.password, 'email': data.email, 'phone': data.phone, 'mfa_method': data.mfa_method, 'mfa_available_methods': data.mfa_available_methods, 'mfa_required': data.mfa_status});
        return;
      } else if (data.mfa_status === 'required-not-configured') {
        SimpleModal.show(modals.MFA_SETUP, {'username': data.username, 'password': data.password, 'id': data.session.user_info.id, 'email': data.session.user_info.email, 'phone': data.session.user_info.phone, 'mfa_method': data.mfa_method, 'mfa_available_methods': data.mfa_available_methods});
        return;
      }
      if (mfaToken !== '') {
        Toast.error(toastStatus.oops);
      }
    }
    localStorage.setItem('group_id', data.session.current_role.group_id);

    if (data.session.user_info?.type === userTypes.PARENT) {
      routerInstance.navigate(pages.PARENT_DASHBOARD, {});
    } else if (data.session.redirect_uri) {
      window.location.href = data.session.redirect_uri;
    } else {
      routerInstance.navigate(url, {});
    }

    // Get Session Data, show notification
    if (data.session.user_info.type === userTypes.TEACHER && data.session.user_profiles.length > 1) {
      for (let i = 0; i < data.session.user_profiles.length; i++) {
        const profile = data.session.user_profiles[i];
        if (profile.last_used === 0) {
          Toast.success(this.i18n._r(await this.i18n.__('<tt-NjE7sElc>', 'You have been granted access to %r1%.'), profile.group_name));
        }
      }
    }
  }
}

export {
  LoginActions
};
